import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { fromEvent, map, Subject, Subscription, takeUntil } from 'rxjs';
import { environment } from './../environments/environment';
import { User } from './models/user.model';
import { UserStore } from './services/stores/user.store';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'dr-ops-stream-ui-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  protected navbarUrl = environment.brands.enelx.globalNavUrl;
  private readonly translateService = inject(TranslateService);
  private readonly userStore = inject(UserStore);
  private readonly destroy$ = new Subject<void>();
  isRouteLoading = signal(false);

  constructor(private router: Router) {
    const defaults = environment.defaults;
    const locale = localStorage.getItem('locale') || defaults.locale || 'en-us';
    const brand = localStorage.getItem('brand') || defaults.brand || 'enelx';

    const langTag = `${locale}.${brand.toUpperCase()}`;

    this.translateService.setFallbackLang(langTag);
    this.translateService.use(langTag);

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.isRouteLoading.set(true);
      }

      if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.isRouteLoading.set(false);
      }
    });
  }

  ngOnInit(): void {
    fromEvent<CustomEvent>(window, 'user')
      .pipe(
        map((e) => e.detail?.user as User),
        takeUntil(this.destroy$)
      )
      .subscribe((user) => {
        console.log('User loaded:', user);
        if (user) {
          this.userStore.setUser(user);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
